var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanknote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.45703H20C21.1046 6.45703 22 7.35246 22 8.45703V16.457C22 17.5616 21.1046 18.457 20 18.457H4C2.89543 18.457 2 17.5616 2 16.457V8.45703C2 7.35246 2.89543 6.45703 4 6.45703Z",
    fill: "#A1A1A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.45703H20V5.45703H4V7.45703ZM20 7.45703C20.5523 7.45703 21 7.90475 21 8.45703H23C23 6.80018 21.6569 5.45703 20 5.45703V7.45703ZM21 8.45703V16.457H23V8.45703H21ZM21 16.457C21 17.0093 20.5523 17.457 20 17.457V19.457C21.6569 19.457 23 18.1139 23 16.457H21ZM20 17.457H4V19.457H20V17.457ZM4 17.457C3.44772 17.457 3 17.0093 3 16.457H1C1 18.1139 2.34315 19.457 4 19.457V17.457ZM3 16.457V8.45703H1V16.457H3ZM3 8.45703C3 7.90475 3.44772 7.45703 4 7.45703V5.45703C2.34315 5.45703 1 6.80018 1 8.45703H3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.457C13.1046 14.457 14 13.5616 14 12.457C14 11.3525 13.1046 10.457 12 10.457C10.8954 10.457 10 11.3525 10 12.457C10 13.5616 10.8954 14.457 12 14.457Z",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.457H18.01M6 12.457H6.01H6Z",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanknote);
export default __webpack_public_path__ + "static/media/banknote.9301476daa877fe35bbb8ba6c9840318.svg";
export { ForwardRef as ReactComponent };